import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Headers, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { AuthService } from './auth.service';

import { environment } from '../../environments/environment';

@Injectable()
export class CategoryService {

    apiUrl = environment.apiUrl;

    constructor(private http: Http,
        private authService: AuthService) { }

    getCategories(): Observable<any> {
        let token = 'Bearer ' + this.authService.getUserToken();

        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);

        return this.http.get(this.apiUrl + '/category', { headers: headers })
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body;
    }

    private handleError(error: Response | any) {
        let errMsg: any;
        if (error instanceof Response) {
            errMsg = error.json();
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
}
